import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingPlansComponent } from './pricing-plans.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { DesignUtilitiesModule } from 'src/app/appModules/design-utilities.module';
import { NgxStripeModule } from 'ngx-stripe';
import { StripeCardPaymentComponent } from './stripe-card-payment/stripe-card-payment.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PricingPlansComponent, StripeCardPaymentComponent],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    DesignUtilitiesModule,
    NgxStripeModule,
    TranslateModule,
  ],
  exports: [PricingPlansComponent, TranslateModule],
})
export class PricingPlansModule {}
